import { COMPENSATION_STATUS_COMPENSATED, COMPENSATION_STATUS_FAILED } from 'constants/compensation';

// Mutation for updating all cached Products to align with Salesforce status (instead of passing props to all nested components)
const updateProductsWithSalesforceStatus = async (_, { tickets = [] }, { cache }) => {
  tickets.forEach(({ ticketNumber, status, method }) => {
    if (status === COMPENSATION_STATUS_COMPENSATED || status === COMPENSATION_STATUS_FAILED) {
      cache.modify({
        id: `BookingItem:${ticketNumber}`,
        fields: {
          isCheckedIn: () => false,
          isPrrAttempted: () => status === COMPENSATION_STATUS_FAILED,
          isPrrRefunded: () => status === COMPENSATION_STATUS_COMPENSATED,
          refundMethod: () => method
        }
      });
    }
  });

  return null;
};

export default updateProductsWithSalesforceStatus;
